import React, {ReactNode} from 'react'
import styled from 'styled-components'
import {Copyable} from './library/copy'
import {Icon} from './library/icon/icon'
import {ElapsedAbsoluteTime} from './formatters'

type OverflowFooterProps = {
  id?: string | number
  updated?: string | null
  published?: string | null
  created?: string | null
  rows?: ReactNode[]
}

export const OverflowFooter = ({
  id,
  updated,
  published,
  created,
  rows
}: OverflowFooterProps) => {
  const hasBeenUpdated = updated === created ? false : true
  return (
    <>
      <StyledOverflowFooter>
        <FooterIcon>
          <Icon name="info" />
        </FooterIcon>
        <FooterContent>
          {rows?.map((row, i) => (
            <FooterRow key={i}>{row}</FooterRow>
          ))}
          {created && (
            <FooterRow>
              <Updated>
                Created: <ElapsedAbsoluteTime lowerCase={true} date={created} />
              </Updated>
            </FooterRow>
          )}
          {published && (
            <FooterRow>
              <Updated>
                Published:{' '}
                <ElapsedAbsoluteTime lowerCase={true} date={published} />
              </Updated>
            </FooterRow>
          )}
          {hasBeenUpdated && updated && (
            <FooterRow>
              <Updated>
                Edited: <ElapsedAbsoluteTime lowerCase={true} date={updated} />
              </Updated>
            </FooterRow>
          )}
          {id && (
            <FooterRow>
              <Copyable value={id}>
                {copying => (
                  <IdWrap>
                    {copying ? (
                      <Copy>Copied</Copy>
                    ) : (
                      <>
                        <Label>ID:</Label>
                        <Id>{id}</Id>
                      </>
                    )}
                  </IdWrap>
                )}
              </Copyable>
            </FooterRow>
          )}
        </FooterContent>
      </StyledOverflowFooter>
    </>
  )
}

const IdWrap = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`

const Label = styled.div`
  color: ${p => p.theme.grey50};
  margin-right: 5px;
`

const Id = styled.div`
  font-family: atomic___SanFranciscoMono, monospace;
  color: ${p => p.theme.grey50};
  flex: 1;
`

const Copy = styled.div`
  color: ${p => p.theme.blue};
  font-weight: bold;
`

const Updated = styled.div`
  display: flex;
  align-items: center;
  color: ${p => p.theme.grey50};
`

const FooterIcon = styled.div`
  width: 20px;
  margin: 10px 10px 10px 0;
  color: ${p => p.theme.grey50};
  align-items: flex-start;
  justify-content: center;
  display: flex;
  flex: none;
`

const FooterContent = styled.div`
  color: ${p => p.theme.grey50};
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 10px 0;
`
const FooterRow = styled.div`
  font-size: ${p => p.theme.fontSizeS};
  min-height: 20px;
  align-items: center;
  display: flex;
  line-height: ${p => p.theme.lineHeightCompact};
`

const StyledOverflowFooter = styled.div`
  display: flex;
  padding: 0 20px;
`
